import { api } from "../../lib/api";

export type SizeGuide = {
  id: number;
  name: string;
  values: string[];
  active: boolean;
  _count: { products: number };
};

export const sizeGuidesApi = {
  list: (active?: boolean) => {
    const query = active === undefined ? "" : `?active=${active}`;
    return api<SizeGuide[]>(`/api/size-guides${query}`);
  },
  create: (body: { name: string; values: string[] }) =>
    api<SizeGuide>("/api/size-guides", { body }),
  update: (id: number, body: Partial<{ name: string; values: string[]; active: boolean }>) =>
    api<SizeGuide>(`/api/size-guides/${id}`, { method: "PATCH", body }),
};
